import { render, staticRenderFns } from "./CourseUploadDialog.vue?vue&type=template&id=76865298&scoped=true&"
import script from "./CourseUploadDialog.vue?vue&type=script&lang=js&"
export * from "./CourseUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./CourseUploadDialog.vue?vue&type=style&index=0&id=76865298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76865298",
  null
  
)

export default component.exports